import axios from "axios";

const getMedicineUsageList = async (baseUrl, token) => {

    const config = {
        headers: { Authorization: `Bearer ${token}` }
    };

    let getResponse = null

    await axios.get(baseUrl + "/Common/medicine/usages",  config)
        .then((res) => {
            //console.log("res.data: ", res.data)
            getResponse = {
                status: res.data.status,
                data: res.data.data
            }
        }).catch((error) => {
            if (error.response !== undefined) {
                getResponse = {
                    status: error.response.status,
                    data: error.response.status
                }
            }
        });
    return getResponse
}

export default getMedicineUsageList;
